document.addEventListener('DOMContentLoaded', function () {
  const counters = document.querySelectorAll('.factNumber');

  // Funktion für das Hochzählen
  function countUp(el, target) {
    let start = 0;
    const duration = 2000; // Dauer des Zählens in Millisekunden
    const increment = Math.ceil(target / (duration / 16)); // Schrittweise Zunahme
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        start = target; // Sicherstellen, dass die Zielzahl nicht überschritten wird
        clearInterval(timer);
      }
      el.textContent = start;
    }, 16); // 16ms für flüssige Animation (≈60fps)
  }

  // Intersection Observer für Sichtbarkeit
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = parseInt(el.textContent, 10);
          countUp(el, target);
          observer.unobserve(el); // Nicht erneut beobachten
        }
      });
    },
    { threshold: 0.5 } // Element muss zu 50% sichtbar sein
  );

  // Alle Zahlen "beobachten"
  counters.forEach((counter) => {
    const targetNumber = parseInt(counter.textContent, 10);
    if (!isNaN(targetNumber)) {
      observer.observe(counter);
    }
  });
});